/* eslint-disable max-len */
import styled from 'styled-components';

export const headerFontFamily =
	`'Raleway', -apple-system, BlinkMacSystemFont, 'Roboto', 'Segoe UI', 'Helvetica Neue', Arial, 'Noto Sans', sans-serif`;

export const baseFontFamily =
	`'Inter', -apple-system, BlinkMacSystemFont, 'Roboto', 'Segoe UI', 'Helvetica Neue', Arial, 'Noto Sans', sans-serif`;

export const Title = styled.h1`
	font-family: ${headerFontFamily};
	font-size: 2rem;
	font-weight: 700;
	line-height: 1.5;
	letter-spacing: 0;
	margin-bottom: 1rem;
`;

export const HeaderLg = styled.h2`
	font-family: ${headerFontFamily};
	font-size: 1.625rem;
	font-weight: 700;
	line-height: 1.3;
	letter-spacing: 0;
	margin-bottom: 0.5rem;
`;

export const HeaderMd = styled.h3`
	font-family: ${headerFontFamily};
	font-size: 1.5rem;
	font-weight: 700;
	line-height: 1.2;
	margin-bottom: 0.5rem;
`;

export const HeaderSm = styled.h4`
	font-family: ${headerFontFamily};
	font-size: 1.25rem;
	font-weight: 700;
	line-height: 1.2;
	margin-bottom: 0.5rem;
`;

export const HeaderXSm = styled.h5`
	font-family: ${headerFontFamily};
	font-size: 1rem;
	font-weight: 700;
	line-height: 1.4;
	margin-bottom: 0.5rem;
`;

export const Legend = styled.legend`
	font-family: ${headerFontFamily};
	font-size: 1.25rem;
	font-weight: 700;
	line-height: 1.4;
	margin-bottom: 0.5rem;
`;

export const Label = styled.label`
	display: block;
	margin: 0 0 0.5rem;
	line-height: 1.5;
	color: ${({ theme }) => theme['silver-lighten-20']};
	font-size: 0.9rem;
	font-weight: 700;

	input + span {
		margin-left: 0.5rem;
	}
`;

export const BodyText = styled.p`
	font-family: ${baseFontFamily};
	font-size: 1rem;
	line-height: 1.6;
	margin-bottom: 1rem;
	text-rendering: optimizeLegibility;
`;
